
define('template!ordersUnpaidView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="totals-region"></div>\n<div class="table-region"></div>\n';

}
return __p
};});

